import { createContext, useContext } from 'react';
export const UnsavedChangesHandlersContext = /*#__PURE__*/createContext(undefined);
export const useUnsavedChangesHandlers = () => {
  const context = useContext(UnsavedChangesHandlersContext);
  if (!context) {
    return undefined;
  }
  return context;
};
//# sourceMappingURL=use-unsaved-changes-handlers.js.map